// pendo supported languages: https://support.pendo.io/hc/en-us/articles/360031866452-Localization
const massageLocaleForPendo: any = (locale: string) => {
  let pendoLocale = locale?.replace('_', '-');
  if (pendoLocale === 'es-LA') {
    pendoLocale = 'es-419';
  }
  return pendoLocale;
};

const visitorData = {
  platform: 'IES',
  clientId: window?.appAirDrop?.config?.CLIENT_ID,
  languageCode: massageLocaleForPendo(window?.appAirDrop?.config.locale),
};

export function initializePendo() {
  window?.pendo?.initialize({
    visitor: visitorData,
    disableCookies: 'true',
    analytics: { excludeEvents: ['load', 'click', 'focus', 'submit', 'change', 'track'] },
  });
}

export function changePendoLanguage(locale: string) {
  visitorData.languageCode = massageLocaleForPendo(locale);
  window?.pendo?.updateOptions({
    visitor: visitorData,
  });
}
